export default __webpack_public_path__ + "static/media/downArrow.5b0cf4ba.svg";